import { reportRuntimeError } from "./runtimeErrorReporter";

const ASSET_ERROR_PATTERN =
  /ChunkLoadError|Loading (?:CSS )?chunk [\w-]+ failed|Failed to fetch dynamically imported module|Importing a module script failed|Unexpected token ['"]?</i;
const RECOVERY_KEY = "akas:asset-recovery";
const RECOVERY_WINDOW_MS = 60_000;

const getErrorMessage = (reason) => {
  if (typeof reason === "string") return reason;
  return reason?.message || reason?.reason?.message || "";
};

export const isAssetLoadError = (reason) => ASSET_ERROR_PATTERN.test(getErrorMessage(reason));

export const recoverFromAssetLoadError = (reason) => {
  if (typeof window === "undefined" || !isAssetLoadError(reason)) return false;

  try {
    const now = Date.now();
    const recovery = JSON.parse(window.sessionStorage.getItem(RECOVERY_KEY) || "null");
    const isRecentForThisPage =
      recovery?.path === window.location.pathname && now - Number(recovery?.at || 0) < RECOVERY_WINDOW_MS;

    if (isRecentForThisPage) return false;

    window.sessionStorage.setItem(RECOVERY_KEY, JSON.stringify({ path: window.location.pathname, at: now }));
    window.location.reload();
    return true;
  } catch (_error) {
    return false;
  }
};

export const installRuntimeAssetRecovery = () => {
  if (typeof window === "undefined") return () => {};

  const handleError = (event) => {
    const reason = event?.error || event?.message;
    if (!recoverFromAssetLoadError(reason)) reportRuntimeError(reason, { kind: "window_error" });
  };
  const handleRejection = (event) => {
    if (!recoverFromAssetLoadError(event?.reason)) {
      reportRuntimeError(event?.reason, { kind: "unhandled_rejection" });
    }
  };

  window.addEventListener("error", handleError);
  window.addEventListener("unhandledrejection", handleRejection);

  return () => {
    window.removeEventListener("error", handleError);
    window.removeEventListener("unhandledrejection", handleRejection);
  };
};
